export default "__VITE_ASSET__Brg$QcY3__"